import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { loginCustomer as apiLogin, registerCustomer as apiRegister, getMe } from '../api';

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [token, setTokenState] = useState(localStorage.getItem('customer_token'));
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const t = localStorage.getItem('customer_token');
    if (!t) { setCustomer(null); setLoading(false); return; }
    try {
      const data = await getMe(t);
      setCustomer(data.customer || data);
      setTokenState(t);
    } catch {
      localStorage.removeItem('customer_token');
      setCustomer(null);
      setTokenState(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const data = await apiLogin({ email, password });
    localStorage.setItem('customer_token', data.token);
    setTokenState(data.token);
    setCustomer(data.customer);
    return data;
  };

  const register = async (name, email, password, phone) => {
    const data = await apiRegister({ name, email, password, phone });
    localStorage.setItem('customer_token', data.token);
    setTokenState(data.token);
    setCustomer(data.customer);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('customer_token');
    setCustomer(null);
    setTokenState(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, token, login, register, logout, loading }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export function useCustomerAuth() {
  const ctx = useContext(CustomerAuthContext);
  if (!ctx) throw new Error('useCustomerAuth must be used within CustomerAuthProvider');
  return ctx;
}
